import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { loadAllClients } from 'pages/ClientList/store/thunk';
import { formatPhone } from 'helpers/formatters';
import useDebounce from 'helpers/hooks/useDebounce';

import { useAutoCompleteStyles } from './styles';

import { theme } from 'theme/globalStyles';

export default function ClientFilterAutocomplete({ clientId, onClientChange }) {
  const dispatch = useDispatch();
  const classes = useAutoCompleteStyles();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { allClients } = useSelector(state => state.clientList);

  const [inputValue, setInputValue] = useState('');
  const debouncedInputValue = useDebounce(inputValue, 1000);

  const formattedClients = allClients?.map(client => {
    let parsedPhones = [];

    try {
      parsedPhones = JSON.parse(client?.phones || []);
    } catch (error) {
      parsedPhones = [];
    }

    return {
      value: client?.clientId,
      label: parsedPhones?.length > 0 ? `${client?.name} - ${formatPhone(client?.phones)}` : client?.name,
      name: client?.name
    };
  });

  useEffect(() => {
    if(debouncedInputValue?.length > 1) {
      dispatch(loadAllClients(userId, establishmentId, debouncedInputValue));
    }
  }, [debouncedInputValue]);

  useEffect(() => {
    if(!clientId) {
      setInputValue('');
    }
  }, [clientId]);

  return(
    <Autocomplete
      id='clientId'
      classes={classes}
      options={formattedClients || []}
      value={formattedClients?.find(client => client.value == clientId) || null}
      inputValue={inputValue || ''}
      onInputChange={(_, value, reason) => {
        if(reason == 'clear') {
          setInputValue('');
          onClientChange('');
        }

        if(reason != 'reset') {
          setInputValue(value);
        }
      }}
      onChange={(_, params) => {
        const { value, name } = params || {};

        if(!value) {
          setInputValue('');
          onClientChange('');
          return;
        }

        setInputValue(name);
        onClientChange(value);
      }}
      getOptionLabel={option => option?.label || ''}
      getOptionSelected={(option, value) => option?.value == value?.value}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          color="primary"
          label="Nome do cliente"
          inputProps={{
            ...params.inputProps,
            style: {
              height: 20,
              color: theme.palette.primary.main
            }
          }}
          InputLabelProps={{
            sx: {
              '&.Mui-focused': {
                color: theme.palette.primary.main
              }
            }
          }}
          SelectProps={{
            MenuProps: {
              disableEnforceFocus: true
            }
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: theme.palette.primary.main
              }
            }
          }}
        />
      )}
    />
  );
}